var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Person",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 32.3",
    style: {
      enableBackground: "new 0 0 30 32.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:currentColor;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icon-bckgrd",
    y: 2.3,
    className: "st0",
    width: 30,
    height: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Head",
    className: "st1",
    d: "M15,18.3c2.8,0,5.3-2.7,5.5-6c0.1-0.8,0-1.6-0.2-2.3l0.9-3.7l-2.3,1.4c-0.1-0.1-0.1-0.1-0.2-0.2 l0.4-3.9l-2.4,2.7l-1.3-3.6l-1.7,2.6L11.2,2l1.3,4.8c-1.7,0.9-3,2.7-3,4.8c0,0.2,0,0.5,0,0.7C9.7,15.6,12.2,18.3,15,18.3z  M12.9,8.5l0.8,3c0,0-0.1-2,2.5-2c1.1,0,2,0.5,2.5,1.2c0.1,0.3,0.1,0.6,0.2,1c0,0.2,0,0.3,0,0.5c-0.2,2.4-1.9,4.4-3.8,4.4 s-3.6-2-3.8-4.4C11,10.7,11.7,9.3,12.9,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Body",
    className: "st1",
    d: "M26.1,27.6c-0.4-2.5-2-5.1-4.1-6.5S17.5,19,15,19l0,0c-2.5,0-4.9,0.7-6.9,2.1 c-2.1,1.4-3.6,3.6-4,6.1c-0.2,0.9,0.3,1.9,1.3,2.1c0.1,0,0.2,0,0.4,0.1h18.6C25.4,29.4,26.1,28.6,26.1,27.6 C26,27.5,26.1,27.7,26.1,27.6z M24.3,27.5v0.1H5.7v-0.1c0.4-2.1,1.6-3.9,3.3-5c1.8-1.2,3.9-1.8,6-1.8s4.2,0.6,6,1.8 C22.7,23.7,23.9,25.5,24.3,27.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpikeIcon);
export default __webpack_public_path__ + "static/media/SpikeIcon.c5ee264c40598f72d6fcebc19a3dbd4e.svg";
export { ForwardRef as ReactComponent };